import React from 'react';

import SmallFilmListItem, { Props as SmallFilmListItemProps } from '../list-item/SmallFilmListItem';

const ContentBlockFilm: React.FC<Omit<SmallFilmListItemProps, 'size'>> = props => (
    <SmallFilmListItem mb={6} {...props} />
);

export default ContentBlockFilm;
